module.exports = __webpack_public_path__ + "static/media/document_mapping.4891ff1b.svg";